export default __webpack_public_path__ + "email.ead6c0996bfe6fd67038afcfcae59650.svg";